import React from 'react';
import { motion } from 'framer-motion';
import { X, Info } from 'lucide-react';

export const WelcomeOnboarding = ({ user, onDismiss }: { user: any; onDismiss: () => void }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gradient-to-r from-emerald-600/20 to-cyan-600/20 border border-emerald-500/20 rounded-[1.5rem] p-6 mb-8 relative overflow-hidden"
    >
      <div className="relative z-10 flex items-center justify-between">
        <div>
          <h2 className="text-xl font-black text-white uppercase tracking-tight">¡Bienvenido, {user?.email?.split('@')[0]}!</h2>
          <p className="text-sm text-emerald-400/80 font-medium mt-1">Explora la inteligencia estructural de la Gobernanza COPARMEX.</p>
        </div>
        <button onClick={onDismiss} className="text-white/40 hover:text-white transition-colors">
          <X size={20} />
        </button>
      </div>
    </motion.div>
  );
};

export const EmptyState = ({ title, description, icon: Icon }: { title: string; description: string; icon: any }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center px-4">
      <div className="w-16 h-16 rounded-2xl bg-white/5 flex items-center justify-center mb-4 text-white/20">
        <Icon size={32} />
      </div>
      <h3 className="text-lg font-black text-white uppercase tracking-tight">{title}</h3>
      <p className="text-sm text-white/40 max-w-xs mt-2">{description}</p>
    </div>
  );
};
